export default __webpack_public_path__ + "static/b2-ab628442728413b35061eac2c2ac567c.png";